<template>
  <div>
    <div class="contact">
      <el-form :model="ruleForm" ref="topRuleForm" label-width="100px">
        <el-form-item label="联系电话:">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="微信:">
          <el-input v-model="ruleForm.wechat"></el-input>
        </el-form-item>
        <el-form-item label="传真:">
          <el-input v-model="ruleForm.fax"></el-input>
        </el-form-item>
        <el-form-item label="地址:">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱:">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="bottom" v-if="personType">
      <el-button @click="submitForm()" type="primary">确定</el-button>
      <el-button type="info" @click="cancelItem">取消</el-button>
    </div> -->
  </div>
</template>

<script>
import { addContact, getContact } from "@/api/talent.js";
export default {
  props: {
    // 当前行的数据
    personData: {
      type: Object,
    },
    // 0 新增 1 编辑
    personType: {
      type: Number,
    },
  },
  data() {
    return {
      // 表单数据
      ruleForm: {
        phone: "",
        wechat: "",
        fax: "",
        address: "",
        email: "",
      },
    };
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem("token");
    },
  },
  created() {
    if (this.personType) {
      this.getContacts();
    } else {
    }
  },
  methods: {
    // 查询联系方式信息
    async getContacts() {
      const res = await getContact(this.personData.personCode);
      if (res.code === 200 && res.data !== null) {
        this.ruleForm = res.data;
      } else {
      }
    },
    // 修改
    async submitForm() {
      Object.assign(this.ruleForm, {
        Authorization: this.Authorization,
        personCode: this.personData.personCode,
      });
      const res = await addContact(this.ruleForm);
      if (res.code === 200) {
        return 200;
      }
    },
    cancelItem() {
      this.$router.go(-1);
    },
  },
  mounted() {
    if (this.personType) {
      document.getElementsByClassName("contact")[0].style.height =
        document.body.clientHeight - 374 + "px";
    }
  },
};
</script>

<style scoped lang="less">
/deep/ .el-input__inner {
  width: 470px;
}
.contact {
  // height: 560px;
}
.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  .el-button {
    margin: 0 20px;
  }
}
</style>
